import { faImage } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Spinner } from '@kcftech/design-system';
import { IPictureFileMetadataResponse } from '@kcftech/prometheustypescriptapiclient';
import { AuthorizedImage } from 'components/image/AuthorizedImage';
import { ArrowLink } from 'components/link/ArrowLink';
import { CellNameText } from 'pages/Settings/FileLibrary/styled';
import styled from 'styled-components';
import { Environment } from 'utils/EnvironmentHelper';
import { appendToRoute, getLocationFileLibraryBaseRoute } from 'utils/RouteHelper';

const Thumbnail = styled(AuthorizedImage)`
    height: auto;
    max-height: 4.8rem;
    width: 4.8rem;
    max-width: 4.8rem;
    margin-right: 1rem;
`;

export type FileData = Pick<
    IPictureFileMetadataResponse,
    'Id' | 'DisplayName' | 'FileName' | 'ThumbnailFileName'
> & {
    LocationId: string | undefined;
};

// Construct the URL to obtain files from S3
export const getFileThumbnailUrl = (picture: FileData) =>
    `${Environment.apiBaseUrl}/api/v3.0/Files/object/${picture.ThumbnailFileName}`;

export type ImageFileNameCellProps = Readonly<{
    fileData: FileData;
    enableModal: boolean;
    url: string;
}>;

export function ImageFileNameCell({
    fileData,
    enableModal,
    url,
}: ImageFileNameCellProps) {
    return (
        <>
            <Thumbnail
                src={getFileThumbnailUrl(fileData)}
                aria-label={`Thumbnail for ${fileData.DisplayName}`}
                alt={`Thumbnail for ${fileData.DisplayName}`}
                pending={<Spinner className="pr-15" />}
                imageScaling="contain"
                fallback={
                    <FontAwesomeIcon
                        icon={faImage}
                        color="var(--icon-action-active)"
                        title="Image"
                        aria-label="Image"
                        size="3x"
                        className="mr-10"
                    />
                }
            />
            <ArrowLink
                to={
                    // To navigate to the settings/FileLibrary from the modal, we must obtain the route
                    enableModal
                        ? getLocationFileLibraryBaseRoute(
                              fileData.LocationId ?? '',
                              fileData.Id
                          )
                        : appendToRoute(url, fileData.Id)
                }
                target={enableModal ? '_blank' : ''}
                rel={enableModal ? 'noreferrer noopener' : ''}
                iconColor="var(--icon-action-active)"
            >
                <CellNameText className="ellipsis-1-line" title={fileData.DisplayName}>
                    {fileData.DisplayName}
                </CellNameText>
            </ArrowLink>
        </>
    );
}
